<style scoped>
#edit_payroll_header {
	background-color: rgb(252, 252, 252);
}
</style>

<template>
	<v-container id="edit_payroll_header" fluid>
		<v-skeleton-loader
			v-if="loading"
			type="list-item-avatar-two-line"
			width="100%"
		/>
		<v-alert type="error" v-if="errormsg != ''">
			{{errormsg}}
		</v-alert>
		<v-payroll-header-entry
			v-if="payroll_header.id != 0"
			:payroll_header="payroll_header"
			:popup_editors="true"
		/>
	</v-container>
</template>

<script>
import PayrollHeader from "@/models/payroll/payroll_header"

import payroll_header_entry from "@/components/addressbook/payroll_header/payroll_header_entry"

export default {
	components: {
		'v-payroll-header-entry': payroll_header_entry,
	},
	data() {
		return {
			errormsg: '',
			loading: false,
			payroll_header: new PayrollHeader(), // our payroll header
		}
	},
	mounted() {
		this.load(this.$route.params.adbid, this.$route.params.pahid);

		/* to keep document360-widget-iframe non-showing */
		/* TODO this should be centralised somewhere!!!! */
		const widget_name_str = 'beacon-container';
		const child = document.getElementById(widget_name_str);	

		if (child) {
			child.style.display = 'none';
		}	else {
			const body_arr = document.getElementsByTagName('body');
			const target_node = body_arr[0];
			const config = { childList: true};
			let isIframe = false;

			const callback = (mutationsList) => {
				mutationsList.forEach((item) => {
					if (item.type == 'childList') {
						const childNodes = item.target.childNodes;
						childNodes.forEach(c => {
							if (c.id === widget_name_str) {
								isIframe = true;
								const child_new = document.getElementById(widget_name_str);
								child_new.style.display = 'none';
							}
						});
					}
				});
			};

			const observer = new MutationObserver(callback);
			observer.observe(target_node, config);
			if (isIframe) {
				observer.disconnect();
			}
		}
	},
	methods: {
		load(adbid, pahid) {
			let self = this;
			self.loading = true;
			self.errormsg = "";

			self.payroll_header.load(adbid, pahid)
				.then(function() {
					self.loading = false;
				})
				.catch(function(reason) {
					self.errormsg = reason;
					self.loading = false;
				})
		}
	},
	watch: {
		'$route.params.pahid': function(pahid) {
			this.$nextTick(() => {
				this.load(this.$route.params.adbid, pahid);
			});
		}
	},
}
</script>

